import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[appShowpopup]',
    standalone: false
})
export class ShowpopupDirective {

  constructor(public viewPopup:ViewContainerRef) { }

}
